import { render, staticRenderFns } from "./ProductDescriptionTranslationModal.vue?vue&type=template&id=d3586c5e"
import script from "./ProductDescriptionTranslationModal.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionTranslationModal.vue?vue&type=script&lang=js"
import style0 from "./ProductDescriptionTranslationModal.vue?vue&type=style&index=0&id=d3586c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports